import { AnswerItem } from '@insta-club/models';
import { cn, sanitizeHtml } from '@insta-club/utilities';
import Image from 'next/image';
import { FolderIcon } from '@insta-club/components';

const isImage = (url: string) => /\.(png|jpe?g|gif|webp|avif)$/i.test(url);

function TicketDescription({ item }: { item: AnswerItem }) {
    const cleanHtml = sanitizeHtml(item.description);

    const handleDownload = (e: React.MouseEvent<HTMLDivElement>) => {
        e.preventDefault();
        if (item.attachment) {
            const link = document.createElement('a');
            link.href = item.attachment;
            link.download = item.attachment.split('/').pop() ?? '';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        }
    };

    return (
        <div className='mx-auto my-6 w-full max-w-[600px]'>
            <div className='rounded-2xl border border-gray-200 bg-white p-5 shadow-sm'>
                {item.title ? (
                    <div className='mb-3 text-center text-base font-semibold text-gray-800'>{item.title}</div>
                ) : null}

                <div
                    className='text-sm leading-7 whitespace-pre-wrap text-gray-600 [&_a]:text-blue-600 [&_a]:underline'
                    dangerouslySetInnerHTML={{ __html: cleanHtml }}
                ></div>

                {item.attachment ? (
                    isImage(item.attachment) ? (
                        <a href={item.attachment} target='_blank' rel='noreferrer' className='mt-4 block'>
                            <Image
                                height={400}
                                width={600}
                                src={item.attachment}
                                alt='Attachment'
                                className='h-auto w-full max-w-full rounded-xl border border-gray-200'
                            />
                        </a>
                    ) : (
                        <div onClick={handleDownload} className='mt-4 flex cursor-pointer items-center gap-2 justify-center'>
                            <span
                                dir='ltr'
                                className='relative top-[1px] line-clamp-1 !font-sans text-xs underline text-gray-600'
                            >
                                {item.attachment.split('/').pop()}
                            </span>
                            <FolderIcon width={38} height={38} />
                        </div>
                    )
                ) : null}
            </div>
        </div>
    );
}

export default TicketDescription;
